import type { ReactNode } from "react";

import { Icon_FillerSvg24 } from "./FillerSvg";

import style from "./SingleIconLabel.module.css";

export const SingleIconLabel: React.FC<{ icon: ReactNode; label: string }> = ({ icon, label }) => {
  return (
    <div className={style.singleIconLabel}>
      {icon ? icon : <Icon_FillerSvg24 />}
      <span>{label}</span>
    </div>
  );
};
